import { useTheme } from '@mui/material/styles';
import { HelpOutlineOutlined } from '@mui/icons-material';

import locales from '../../../../../../../constants/locales';
import DetailsList from '../../../../../../common/details-list';
import { formatToAmount } from '../../../../../../../constants/helpers/utils';
import { detailsValueFormatter } from '../../../../../../../utils/details';
import DetailsFactory from '../../../../../../common/details-list/detailsFactory';

import { OperationFailed } from './interfaces';

interface Props {
  operation: OperationFailed;
}

const UnknownOperation = ({ operation }: Props) => {
  const theme = useTheme();
  const { cost, msisdn } = operation;

  return (
    <DetailsFactory
      header={{
        icon: { component: HelpOutlineOutlined, color: theme.palette.grey['700'] },
        id: operation.id,
        date: operation.date,
        status: operation.status
      }}
      operationContent={
        <DetailsList
          items={[
            { label: locales.operation.label.cost, value: formatToAmount(cost.value) },
            {
              label: locales.operation.label.recipient,
              value: detailsValueFormatter(msisdn)
            }
          ]}
        />
      }
    />
  );
};

export default UnknownOperation;
